import React from 'react';
import {DocInterface} from '../../interfaces/docInterface';
import docPath from '../../helpers/docPath';

export default function Item(props: DocInterface) {
  return (
    <div>
        <div className='doc'>
            <img src="/images/google-docs.png" />
            <div className='detail'>
                <div>{props?.name}</div>
                <div><a href={docPath(props?.path)} target="_blank" download>Download</a></div>
            </div>
        </div>
    </div>
  )
}
